/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, extendObservable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { PrebuiltEntityStore } from 'src/luis/types/stores/entities/PrebuiltEntityMetadataStore';
import { PrebuiltEntityStoreHouse } from 'src/luis/types/stores/entities/PrebuiltEntityStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

/**
 * A factory function for creating an prebuilt entity store house,
 * which houses an array of prebuilt entity stores.
 */
export const createPrebuiltEntityStoreHouse = (): PrebuiltEntityStoreHouse => {
    const resourcesStoreHouse = createResourceStoreHouse<PrebuiltEntityStore>();

    const prebuiltEntityStoreHouse: SubtractStore<PrebuiltEntityStoreHouse, ResourceStoreHouse<PrebuiltEntityStore>> = {
        /**
         * Finds an entity by the given name and returns undefined
         * if not found.
         *
         * @param name The name to search with.
         * @returns The entity or undefined if not found.
         */
        findByName(name) {
            return this.items.find(i => i.name === name);
        }
    };

    return extendObservable(resourcesStoreHouse, prebuiltEntityStoreHouse, { findByName: action }, { deep: false });
};
